<template>
  <main id="main">
    <div style="height: 45vh; margin-bottom: 6rem" class="bg_light_theme w-100 rounded_div position-relative">
      <div style="bottom: -5rem" class="w-100 d-flex justify-content-center position-absolute">
        <img src="@/assets/imgs/frinds.png" class="friends" alt="">
      </div>
    </div>

    <div class="p-3">
      <div class="mb-5">
        <p class="mb-4 bold">{{ t('select_lang') }}</p>
        <div class="d-flex align-items-center justify-content-between w-100">
          <p @click="selectLanguage('dari')" :class="['shadow_input p-4 rounded-pill text-center w-45', selectedLanguage === 'dari' ? 'bg_light_theme text_color_white' : 'bg_white']">{{ t('persian_dari') }}</p>
          <p @click="selectLanguage('pashto')" :class="['shadow_input p-4 rounded-pill text-center w-45', selectedLanguage === 'pashto' ? 'bg_light_theme text_color_white' : 'bg_white']">{{ t('pashto') }}</p>
        </div>
      </div>

      <div class="mb-6">
        <p class="mb-4 bold">{{ t('select_role') }}</p>
        <div class="d-flex align-items-center justify-content-between w-100">
          <p @click="selectRole('teacher')" :class="['shadow_input p-4 rounded-pill text-center w-45', selectedRole === 'teacher' ? 'bg_light_theme text_color_white' : 'bg_white']">{{ t('i_am_teacher') }}</p>
          <p @click="selectRole('student')" :class="['shadow_input p-4 rounded-pill text-center w-45', selectedRole === 'student' ? 'bg_light_theme text_color_white' : 'bg_white']">{{ t('i_am_student') }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <button class="button" @click="submitSelection">{{ t('submit_continue') }}</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LanguageView',
  data() {
    return {
      selectedLanguage: null,
      selectedRole: null
    }
  },
  mounted() {
    // This logic ensures that if the user logged out and landed here, 
    // pressing back will exit to Google instead of going back to the user panel.
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', this.handleBackNavigation);
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handleBackNavigation);
  },
  methods: {
    handleBackNavigation() {
        // Redirect to Google if back is pressed
        window.location.href = "https://www.google.com";
    },
    selectLanguage(lang) {
      this.selectedLanguage = lang
      const langMap = { 'dari': 'fa', 'pashto': 'ps' }
      const serverLang = langMap[lang] || 'fa'
      localStorage.setItem('app_lang', serverLang)
      this.$forceUpdate() 
    },
    selectRole(role) {
      this.selectedRole = role
      localStorage.setItem('app_role', role)
    },
    submitSelection() {
      if (!this.selectedLanguage || !this.selectedRole) {
        alert('لطفا زبان و نقش خود را انتخاب کنید')
        return
      }

      if (this.selectedRole === 'teacher') {
        this.$router.push({ name: 'TeacherLogin' })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style scoped>
.rounded_div {
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}
.friends {
  width: 100%;
  height: auto;
  max-width: 40rem;
}
.shadow_input {
  transition: transform 0.3s ease, background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.shadow_input.bg_light_theme {
  transform: scale(1.05);
}
</style>